





























import { Component, Prop, PropSync } from 'vue-property-decorator'
import Vue from 'vue'
import HdsOverlay from '@/components/HdsOverlay.vue'

export const elevations = [
  'shadow-none',
  'shadow-sm',
  'shadow',
  'shadow-md',
  'shadow-lg',
  'shadow-xl',
  'shadow-2xl',
]

/**
 * 다이얼로그 컴포넌트입니다.
 * 가장 주목도와 중요도가 높고, 사용자의 액션을 막고 우선적으로 할 행동을 지정합니다.
 */
@Component({
  components: { HdsOverlay },
})
export default class HdsDialog extends Vue {
  name = 'HdsDialog'
  isAnimating: boolean = false

  @PropSync('on', { type: Boolean, default: false }) onSync!: boolean

  /**
   * Elevation 값입니다. (Box Shadow) 0~6
   */
  @Prop({ type: Number, default: 6 }) elevation!: number

  /**
   * Fixed or Absolute
   */
  @Prop({ type: Boolean, default: false }) fixed!: boolean

  /**
   * 다이얼로그 컨테이너의 너비를 지정합니다.
   */
  @Prop({ type: String, default: 'auto' }) width!: string

  /**
   * 다이얼로그 컨테이너의 높이를 지정합니다.
   */
  @Prop({ type: String, default: 'auto' }) height!: string

  /**
   * 다이얼로그 컨테이너의 최대 너비를 지정합니다.
   */
  @Prop({ type: String, default: '300px' }) maxWidth!: string

  /**
   * 다이얼로그 컨테이너의 최대 높이를 지정합니다.
   */
  @Prop({ type: String, default: '300px' }) maxHeight!: string

  /**
   * 오버레이를 클릭했을때 창을 닫는 기능을 비활성화 합니다.
   */
  @Prop({ type: Boolean, default: false }) noClickOutside!: boolean

  /**
   * 오버레이 색상을 변경합니다.
   */
  @Prop({ type: String, default: 'rgba(0, 0, 0, 0.25)' })
  overlayColor!: string

  get dialogClasses() {
    return {
      'hds-dialog': true,
      'hds-fixed': this.fixed,
      [elevations[Number(this.elevation)]]: true,
      'hds-no-click-outside': this.noClickOutside && this.isAnimating,
      'hds-on': this.onSync,
      'hds-off': !this.onSync,
    }
  }

  get dialogStyles() {
    return {
      width: this.width,
      height: this.height,
      maxWidth: this.maxWidth,
      maxHeight: this.maxHeight,
    }
  }

  get titleClasses() {
    return {
      'hds-title': true,
    }
  }

  get contentClasses() {
    return {
      'hds-content': true,
    }
  }

  get actionsClasses() {
    return {
      'hds-actions': true,
    }
  }

  onClickOverlay() {
    if (this.noClickOutside) {
      this.isAnimating = true
      return
    }

    this.onSync = false
  }
}
